export const ru = {
    allTime: 'Всё время',
    currentMonth: 'Этот месяц',
    currentWeek: 'Эта неделя',
    defaultBudgetMode: 'стандартный',
    last30Days: 'Последние 30 дней',
    last365Days: 'Последние 365 дней',
    last7Days: 'Последние 7 дней',
    last90Days: 'Последние 90 дней',
    previousMonth: 'Предыдущий месяц',
    previousWeek: 'Прошлая неделя',
    'report-enqueued': 'Запрос на отчёт успешно добавлен в очередь',
    stretchedBudgetMode: 'распределённый',
    today: 'Сегодня',
    yesterday: 'Вчера'
};
